import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { API } from "../context/AuthContext";

const AGENTS = [
  { id: "projectLeader",  name: "Líder de Proyecto",        icon: "⭐", color: "#F59E0B", uso: "Visión 360° de todos los agentes y el cliente" },
  { id: "strategist",     name: "Estratega de Cliente",     icon: "🎯", color: "#0b00f9", uso: "Define y vela por objetivos y KPIs" },
  { id: "onboarding",     name: "Analista de Onboarding",   icon: "🔍", color: "#6366f1", uso: "Estudio de mercado inicial" },
  { id: "copywriter",     name: "Copywriter",               icon: "✍️", color: "#ec4899", uso: "Copy para redes y anuncios" },
  { id: "contentPlanner", name: "Planificador de Contenido",icon: "📅", color: "#14b8a6", uso: "Calendario editorial" },
  { id: "adsSpecialist",  name: "Especialista en Ads",      icon: "📢", color: "#f59e0b", uso: "Campañas Meta y Google" },
  { id: "seoAnalyst",     name: "Analista SEO",             icon: "🔎", color: "#22c55e", uso: "Posicionamiento orgánico" },
  { id: "reportAnalyst",  name: "Analista de Reportes",     icon: "📊", color: "#a855f7", uso: "Métricas y conclusiones" },
  { id: "upselling",      name: "Agente de Upselling",      icon: "💡", color: "#f97316", uso: "Oportunidades de servicios adicionales" },
  { id: "competitive",    name: "Analista Competitivo",     icon: "🏆", color: "#ef4444", uso: "Inteligencia de mercado" },
  { id: "qa",             name: "QA de Contenido",          icon: "✅", color: "#64748b", uso: "Revisión antes de entregar al cliente" },
  { id: "uxWriter",       name: "UX Writer",               icon: "🖊️", color: "#8b5cf6", uso: "Microcopy, voz de marca y textos de interfaz" },
  { id: "meetingMinutes", name: "Minutas de Reunión",      icon: "🗒️", color: "#0ea5e9", uso: "Notas de Gemini → minuta profesional para el cliente" },
  { id: "pm",            name: "Project Manager",         icon: "📬", color: "#0ea5e9", uso: "Redacta y envía emails al cliente en nombre del equipo" },
];

export default function Dashboard() {
  const { user } = useAuth();
  const [clients, setClients] = useState([]);
  const [stats, setStats] = useState({ total: 0, active: 0 });
  const [showAgentModal, setShowAgentModal] = useState(false);

  useEffect(() => {
    API.get("/api/clients").then(r => {
      setClients(r.data.filter(c => c.status === "active").slice(0, 5));
      setStats({
        total: r.data.length,
        active: r.data.filter(c => c.status === "active").length,
      });
    }).catch(() => {});
  }, []);

  const hour = new Date().getHours();
  const greeting = hour < 12 ? "Buenos días" : hour < 18 ? "Buenas tardes" : "Buenas noches";
  const firstName = user?.name?.split(" ")[0] || "";

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">{greeting}, {firstName} 👋🏼</h1>
        <p className="page-subtitle">¿Con qué agente trabajamos hoy?</p>
      </div>

      <div className="page-body">
        {/* Stats */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 12, marginBottom: 32 }}>
          <StatCard label="Clientes totales" value={stats.total} />
          <StatCard label="Clientes activos" value={stats.active} accent />
          <StatCard label="Agentes disponibles" value={AGENTS.length} />
        </div>

        {/* Agents header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, color: "var(--text-primary)" }}>Agentes</h2>
          <button
            onClick={() => setShowAgentModal(true)}
            style={{
              background: "none", border: "none", cursor: "pointer",
              fontSize: 13, color: "var(--accent)", fontFamily: "inherit",
              padding: 0,
            }}
          >
            ¿Qué agente usar? →
          </button>
        </div>

        {/* Agents grid */}
        <div className="agent-grid" style={{ marginBottom: 36 }}>
          {AGENTS.map(agent => (
            <Link key={agent.id} to={`/agents/${agent.id}`} style={{ textDecoration: "none" }}>
              <div
                className="card agent-card"
                style={{ cursor: "pointer", transition: "all 0.15s ease", borderColor: "transparent", padding: 20 }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = agent.color + "44"; e.currentTarget.style.background = "var(--bg-elevated)"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = "transparent"; e.currentTarget.style.background = "var(--bg-surface)"; }}
              >
                <div style={{ fontSize: 24, marginBottom: 10 }}>{agent.icon}</div>
                <div style={{ fontSize: 14, fontWeight: 500, color: "var(--text-primary)", flex: 1 }}>{agent.name}</div>
                <div style={{ width: 24, height: 2, background: agent.color, borderRadius: 99, marginTop: 8 }} />
              </div>
            </Link>
          ))}
        </div>

        {/* Recent clients */}
        {clients.length > 0 && (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <h2 style={{ fontSize: 16, fontWeight: 600, color: "var(--text-primary)" }}>Clientes recientes</h2>
              <Link to="/clients" style={{ fontSize: 13, color: "var(--accent)" }}>Ver todos →</Link>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {clients.map(client => (
                <Link key={client.id} to={`/clients/${client.id}`} style={{ textDecoration: "none" }}>
                  <div className="card" style={{ padding: "14px 20px", display: "flex", alignItems: "center", gap: 14 }}>
                    <div style={{
                      width: 36, height: 36, borderRadius: "var(--radius-md)",
                      background: client.primary_color || "#0b00f9",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 14, fontWeight: 600, color: "#fff", flexShrink: 0,
                    }}>
                      {client.name[0].toUpperCase()}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 14, fontWeight: 500, color: "var(--text-primary)" }}>{client.name}</div>
                      <div style={{ fontSize: 12, color: "var(--text-muted)" }}>{client.industry || "Sin rubro"}</div>
                    </div>
                    <span className={`badge ${client.status === "active" ? "badge-green" : "badge-gray"}`}>
                      {client.status === "active" ? "Activo" : "Inactivo"}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Agent modal */}
      {showAgentModal && (
        <div style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)",
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 1000, padding: 24,
        }} onClick={e => e.target === e.currentTarget && setShowAgentModal(false)}>
          <div className="card" style={{ width: "100%", maxWidth: 600, padding: 32, maxHeight: "80vh", overflowY: "auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
              <h2 style={{ fontSize: 18, fontWeight: 600 }}>¿Qué agente usar?</h2>
              <button onClick={() => setShowAgentModal(false)} style={{ background: "none", border: "none", color: "var(--text-muted)", cursor: "pointer", fontSize: 20, lineHeight: 1 }}>×</button>
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid var(--border)" }}>
                  <th style={{ padding: "8px 12px", textAlign: "left", fontSize: 12, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase" }}>Agente</th>
                  <th style={{ padding: "8px 12px", textAlign: "left", fontSize: 12, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase" }}>Uso</th>
                </tr>
              </thead>
              <tbody>
                {AGENTS.map(agent => (
                  <tr key={agent.id} style={{ borderBottom: "1px solid var(--border)" }}>
                    <td style={{ padding: "12px", display: "flex", alignItems: "center", gap: 10 }}>
                      <span style={{ fontSize: 16 }}>{agent.icon}</span>
                      <Link to={`/agents/${agent.id}`} onClick={() => setShowAgentModal(false)} style={{ fontSize: 14, fontWeight: 500, color: "var(--text-primary)", textDecoration: "none" }}>
                        {agent.name}
                      </Link>
                    </td>
                    <td style={{ padding: "12px", fontSize: 14, color: "var(--text-secondary)" }}>{agent.uso}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

function StatCard({ label, value, accent }) {
  return (
    <div style={{
      background: accent ? "var(--accent-dim)" : "var(--bg-surface)",
      border: `1px solid ${accent ? "var(--accent-glow)" : "var(--border)"}`,
      borderRadius: "var(--radius-md)",
      padding: "16px 20px",
    }}>
      <div style={{ fontSize: 12, color: accent ? "var(--accent)" : "var(--text-muted)", marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 28, fontWeight: 600, color: accent ? "var(--accent)" : "var(--text-primary)" }}>{value}</div>
    </div>
  );
}
